export default __webpack_public_path__ + "static/media/Strawberry-Cake.78fc0087.jpg";